export { Text, type TextProps } from './Text';
export {
  TEXT_COLORS,
  textVariants,
  type TextColor,
  type TextVariantProps,
} from './text.variants';
